import { FONT_BASE, FONT_MAX, LINE_HEIGHT_BASE, LINE_HEIGHT_HEADING } from '../themeConstants'

export const muiComponentsMiscControls = {
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme, ownerState }) =>
        ownerState.color === 'default'
          ? {
              color: theme.palette.text.secondary,
            }
          : {},
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        fontSize: FONT_BASE,
        lineHeight: 1.2,
        padding: '3px 4px',
        backgroundColor: 'rgba(43, 43, 43, 0.95)',
        color: theme.palette.common.white,
        borderRadius: 10,
        boxShadow: theme.shadows[2],
      }),
      arrow: {
        color: 'rgba(43, 43, 43, 0.95)',
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: FONT_MAX,
        fontWeight: 600,
        lineHeight: LINE_HEIGHT_HEADING,
      },
    },
  },
  MuiDialogContentText: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: FONT_BASE,
        color: theme.palette.text.secondary,
      }),
    },
  },
}
